import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import EditarManutencaoColeta from './EditarManutencaoColeta';
import Loading from '../../../components/Loading/Loading';

//Api
import ManutencaoOrdemColeta_api from '../../../api/ManutencaoOrdemColeta_api';
import { showMessage } from 'helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function ManutencaoColetas() {
    const [editar, setEditar] = useState(false);

    //items da tabela de manutenção de coleta
    const [items, setItems] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //cabeçalhos da tabela de lista de coletas
    const headers = [
        { value: "Veículo", objectValue: "placaVeiculo" },
        { value: "Motorista", objectValue: "motorista" },
        { value: "Quantidade de coletas", objectValue: "qtdColetas" },
        { value: "Quantidade coletado", objectValue: "qtdColetado" },
        { value: "Quantidade destinado", objectValue: "qtdDestinado" },
        { value: "Status coleta", objectValue: "statusColeta" },
    ]

    //Ação executada ao clicar no botão de editar da lista
    const onClickEditar = (rowData) => {
        setEditar(rowData.idOrdem);
    }

    //Ação executada ao clicar no botão de editar nas outras telas
    const onClickBtnVoltar = () => {
        loadManutencoes();
        setEditar(null);
    }

    //Carrega todas as ordens que podem ser feita a manutenção
    const loadManutencoes = () => {
        setLoading(true);
        ManutencaoOrdemColeta_api.GetList().then(response => {
            setItems(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null)
        }).finally(f => setLoading(false));
    }
    //Ações da tabela
    const actions = [actionsTable.editar(onClickEditar)];

    //Carrega a lista de ordens possiveis de manutenção 
    useEffect(() => {
        loadManutencoes();
    }, []);

    //Controle de exibição da tela de edição
    if (editar) {
        return <EditarManutencaoColeta id={editar} btnVoltar={onClickBtnVoltar} />
    }
    return (
        <MainCard noCard>
            {loading && <Loading />}
            <TabelaListagem actions={actions} title='Lista de Coletas' headers={headers} items={items} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    )
}